export const DEFAULT_PAGE_SIZE = 15;

export const getPageFirstItemIndex = (pageNumber: number) => {
  return (pageNumber - 1) * DEFAULT_PAGE_SIZE;
};
